/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_StapleInputs */

const en_quick_add_staple = /** @type {(inputs: Quick_Add_StapleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staple`)
};

const de_quick_add_staple = /** @type {(inputs: Quick_Add_StapleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorrat`)
};

/**
* | output |
* | --- |
* | "Staple" |
*
* @param {Quick_Add_StapleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_staple = /** @type {((inputs?: Quick_Add_StapleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_StapleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_staple(inputs)
	return en_quick_add_staple(inputs)
});